import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import PostCard from "@/components/PostCard";

export default function Category() {
  const { name } = useParams();
  const decoded = decodeURIComponent(name);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const { data } = await api.get("/posts", { params: { category: decoded } });
        setPosts(data);
      } finally {
        setLoading(false);
      }
    })();
  }, [decoded]);

  return (
    <div className="px-6 md:px-12 lg:px-24 pt-20 md:pt-28" data-testid="category-page">
      <div className="border-b border-black/10 pb-12">
        <div className="text-[11px] uppercase tracking-[0.32em] text-black/55 mb-4">
          Category
        </div>
        <h1 className="font-serif text-5xl md:text-7xl font-light tracking-tighter leading-none">
          {decoded}
        </h1>
      </div>

      {loading ? (
        <div className="py-20 text-center text-sm text-black/40 tracking-widest uppercase">
          Loading…
        </div>
      ) : posts.length === 0 ? (
        <div className="py-32 text-center">
          <p className="font-serif text-2xl text-black/60 italic">
            No entries in this category yet.
          </p>
        </div>
      ) : (
        <div data-testid="category-feed">
          {posts.map((p) => (
            <PostCard key={p.id} post={p} />
          ))}
        </div>
      )}
    </div>
  );
}
